import type { BrowserOptions } from "@sentry/browser";
import type { NodeOptions } from "@sentry/node";

export const config: NodeOptions | BrowserOptions = {
  attachStacktrace: true,
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN ?? "",
  ignoreErrors: ["Network Error", "AbortError", "Failed to register a ServiceWorker", /ezproxy/], // cspell: disable-line
  release: process.env.NEXT_PUBLIC_COMMIT_SHA,
};
